import apiFetch from '@wordpress/api-fetch';
import {useEffect, useState} from "@wordpress/element";



export const useRestConfig = ()=>{
    return WP_OctaviusRocks_Admin.rest || {};
}

export const useTaxonomyTermViews = ()=>{
    const route = useRestConfig().GET_taxonomy_term_views;
    const [views, setViews] = useState([]);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isAtTheEnd, setIsAtTheEnd] = useState(false);
    const [args, setArgs] = useState({});

    useEffect(()=>{
        setIsLoading(true);
        const {
            taxonomy = "",
            from = "",
            until = "",
        } = args;
        apiFetch( {
            path: route+`?page=${page}&taxonomy=${taxonomy}&from=${from}&until=${until}`,
        } ).then( ( result ) => {
            setIsLoading(false);
            if(result.length === 0){
                setIsAtTheEnd(true);
                return;
            }

            if(page === 1){
                setViews(result);
            } else {
                const cleanResult = result.filter(newItem => {
                    return !views.find(item=>{
                        return item.taxonomy === newItem.taxonomy && item.term.term_id === newItem.term.term_id;
                    })
                })
                setViews([...views,...cleanResult]);
            }
            setPage(page+1);
        } );
    }, [page, args]);

    return {
        views,
        setArgs: (_args)=>{
            setPage(1);
            setViews([]);
            setIsAtTheEnd(false);
            setArgs(_args);
        },
        args,
        loadMore: ()=>{
          setPage(page+1);
        },
        isLoading,
        isAtTheEnd
    };
}